import * as $runtime from "../runtime.js";
import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunction from "../Data.Function/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dMap from "../Data.Map/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dTuple$dT2 from "../Data.Tuple.T2/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
const $OMap = (_1, _2) => ({tag: "OMap", _1, _2});
const bind1 = /* #__PURE__ */ (() => Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind)();
const pure = /* #__PURE__ */ (() => Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure)();
const OMap = value0 => value1 => $OMap(value0, value1);
const foldableOMap = {
  foldr: f => z => v => Data$dFoldable.foldrArray(x => f(x._2))(z)(v._2),
  foldl: f => z => v => Data$dFoldable.foldlArray(acc => x => f(acc)(x._2))(z)(v._2),
  foldMap: dictMonoid => {
    const foldMap1 = Data$dFoldable.foldableArray.foldMap(dictMonoid);
    return f => v => foldMap1(x => f(x._2))(v._2);
  }
};
const values = v => Data$dFunctor.arrayMap(Data$dTuple.snd)(v._2);
const union = dictOrd => {
  const compare = dictOrd.compare;
  return v => v1 => {
    const aKeys = Data$dMap.keys(v._1);
    return $OMap(
      Data$dMap$dInternal.unsafeUnionWith(compare, Data$dFunction.const, v._1, v1._1),
      Data$dSemigroup.concatArray(v._2)(Data$dArray.filterImpl(
        v2 => {
          const $0 = v2._1;
          const go = go$a0$copy => {
            let go$a0 = go$a0$copy, go$c = true, go$r;
            while (go$c) {
              const v$1 = go$a0;
              if (v$1.tag === "Leaf") {
                go$c = false;
                go$r = false;
                continue;
              }
              if (v$1.tag === "Node") {
                const v1$1 = dictOrd.compare($0)(v$1._3);
                if (v1$1.tag === "LT") {
                  go$a0 = v$1._5;
                  continue;
                }
                if (v1$1.tag === "GT") {
                  go$a0 = v$1._6;
                  continue;
                }
                if (v1$1.tag === "EQ") {
                  go$c = false;
                  go$r = true;
                  continue;
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            return go$r;
          };
          return !go(aKeys);
        },
        v1._2
      ))
    );
  };
};
const udecodeMap = dictDecode => dictDecode1 => {
  const unsafeDecode = Unscramble.decodeArray(Unscramble.decodeTuple(dictDecode1)(dictDecode).unsafeDecode);
  return dictOrd => {
    const fromFoldable = Data$dMap$dInternal.fromFoldable(dictOrd)(Data$dFoldable.foldableArray);
    return {
      unsafeDecode: f => {
        const kvs = unsafeDecode(f);
        return $OMap(fromFoldable(kvs), kvs);
      }
    };
  };
};
const toMap = v => v._1;
const toArray = v => v._2;
const size = v => v._2.length;
const showOMap = dictShow => dictShow1 => {
  const show = Data$dShow.showArrayImpl(v => "(Tuple " + dictShow.show(v._1) + " " + dictShow1.show(v._2) + ")");
  return {show: v => show(v._2)};
};
const semigroupOMap = dictOrd => ({append: union(dictOrd)});
const move = fromIndex => toIndex => v => {
  const $0 = OMap(v._1);
  const $1 = Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, v._2, fromIndex);
  const $2 = (() => {
    if ($1.tag === "Just") {
      const $2 = Data$dArray._deleteAt(Data$dMaybe.Just, Data$dMaybe.Nothing, fromIndex, v._2);
      if ($2.tag === "Just") { return Data$dArray._insertAt(Data$dMaybe.Just, Data$dMaybe.Nothing, toIndex, $1._1, $2._1); }
      if ($2.tag === "Nothing") { return Data$dMaybe.Nothing; }
      $runtime.fail();
    }
    if ($1.tag === "Nothing") { return Data$dMaybe.Nothing; }
    $runtime.fail();
  })();
  if ($2.tag === "Just") { return Data$dMaybe.$Maybe("Just", $0($2._1)); }
  return Data$dMaybe.Nothing;
};
const lookup = dictOrd => dictEq => needle => v => Data$dMap$dInternal.lookup(dictOrd)(needle)(v._1);
const member = dictOrd => dictEq => needle => haystack => {
  const $0 = Data$dMap$dInternal.lookup(dictOrd)(needle)(haystack._1);
  if ($0.tag === "Nothing") { return false; }
  if ($0.tag === "Just") { return true; }
  $runtime.fail();
};
const keysSet = v => Data$dMap.keys(v._1);
const keys = v => Data$dFunctor.arrayMap(Data$dTuple.fst)(v._2);
const fromArray = dictOrd => {
  const fromFoldable = Data$dMap$dInternal.fromFoldable(dictOrd)(Data$dFoldable.foldableArray);
  return map2 => $OMap(fromFoldable(map2), map2);
};
const findIndex = dictEq => needle => v => Data$dArray.findIndexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, v1 => dictEq.eq(v1._1)(needle), v._2);
const eqOMap = dictEq => dictEq1 => {
  const eq = Data$dEq.eqArrayImpl(x => y => dictEq.eq(x._1)(y._1) && dictEq1.eq(x._2)(y._2));
  return {eq: v => v1 => eq(v._2)(v1._2)};
};
const encodeMap = dictEncode => {
  const encode = Data$dFunctor.arrayMap(dictEncode.encode);
  return {encode: v => encode(Data$dFunctor.arrayMap(v1 => Data$dTuple$dT2.$T2(v1._1, v1._2))(v._2))};
};
const empty = /* #__PURE__ */ $OMap(Data$dMap$dInternal.Leaf, []);
const monoidOMap = dictOrd => {
  const semigroupOMap1 = {append: union(dictOrd)};
  return {mempty: $OMap(Data$dMap$dInternal.Leaf, []), Semigroup0: () => semigroupOMap1};
};
const $$delete = dictOrd => {
  const $0 = dictOrd.Eq0();
  return key => v => $OMap(Data$dMap$dInternal.delete(dictOrd)(key)(v._1), Data$dArray.filterImpl(v1 => !$0.eq(v1._1)(key), v._2));
};
const insert = dictOrd => {
  const delete1 = $$delete(dictOrd);
  return k => v => m0 => {
    const v1 = delete1(k)(m0);
    return $OMap(Data$dMap$dInternal.insert(dictOrd)(k)(v)(v1._1), Data$dArray.snoc(v1._2)(Data$dTuple.$Tuple(k, v)));
  };
};
const decodeMap = dictDecode => {
  const decode = Foreign$dGeneric$dClass.arrayDecode(dictDecode).decode;
  return dictOrd => {
    const fromFoldable = Data$dMap$dInternal.fromFoldable(dictOrd)(Data$dFoldable.foldableArray);
    return {
      decode: f => bind1(decode(f))(v => {
        const kvs$p = Data$dFunctor.arrayMap(v1 => Data$dTuple.$Tuple(v1._1, v1._2))(v);
        return pure($OMap(fromFoldable(kvs$p), kvs$p));
      })
    };
  };
};
export {
  $OMap,
  OMap,
  bind1,
  decodeMap,
  $$delete as delete,
  empty,
  encodeMap,
  eqOMap,
  findIndex,
  foldableOMap,
  fromArray,
  insert,
  keys,
  keysSet,
  lookup,
  member,
  monoidOMap,
  move,
  pure,
  semigroupOMap,
  showOMap,
  size,
  toArray,
  toMap,
  udecodeMap,
  union,
  values
};
